module.exports = __webpack_public_path__ + "img/news16_3.f4a8a7a2.jpg";